export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/FlyerPoster-d34a425c7e25c40ecbc6c1190b350bf5.jpg";